import React, { FC } from 'react';

import { useTheme } from '../../util/theme';

import { PageLayoutWidth } from './PageLayout.types';
import { getClassNames } from './PageLayoutHeroBanner.styles';

export interface PageLayoutHeroBannerProps {
  readonly imgSrc: string;
  readonly topOffset?: number;
  readonly hasHeader?: boolean;
  readonly noSpacing?: boolean;
  readonly fullWidthLayout?: boolean;
  readonly width?: PageLayoutWidth;
}

const PageLayoutHeroBanner: FC<PageLayoutHeroBannerProps> = ({
  imgSrc,
  topOffset = 0,
  fullWidthLayout = false,
  hasHeader = false,
  noSpacing = false,
  width,
}) => {
  const theme = useTheme();
  const { heroBanner, contentWrapperGradient } = getClassNames({
    theme,
    topOffset,
    fullWidthLayout,
    hasHeader,
    noSpacing,
    width,
    imgSrc,
  });

  return (
    <div className={heroBanner}>
      <div className={contentWrapperGradient}></div>
    </div>
  );
};

export default PageLayoutHeroBanner;
